export default "__VITE_ASSET__334e7e9a__"